import { useQuery } from "@tanstack/react-query";
import {
  listOrgsApiAdminOrgsGetOptions,
  listOrgsApiAdminOrgsGetQueryKey,
} from "../generated/api/@tanstack/react-query.gen";
import { updateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatch } from "../generated/api/sdk.gen";
import type { AdminOrgResponse } from "../generated/api/types.gen";
import { useAdminBillingExemptList } from "./useAdminBillingExemptList";

export function useAdminOrgs(debouncedQuery: string) {
  const query = useQuery({
    ...listOrgsApiAdminOrgsGetOptions({ query: { query: debouncedQuery } }),
    placeholderData: (previousData) => previousData,
  });

  const { items, togglingIds, ...rest } = useAdminBillingExemptList<
    AdminOrgResponse,
    "orgs"
  >({
    listKey: "orgs",
    idOf: (org) => org.org_id,
    queryKey: listOrgsApiAdminOrgsGetQueryKey(),
    mutationFn: async ({ id, billingExempt }) => {
      const { data } =
        await updateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatch({
          path: { org_id: id },
          body: { billing_exempt: billingExempt },
        });
      return data;
    },
    query,
  });

  return { orgs: items, togglingOrgs: togglingIds, ...rest };
}
